import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=d67dd984&scoped=true&"
import script from "./Works.vue?vue&type=script&lang=ts&"
export * from "./Works.vue?vue&type=script&lang=ts&"
import style0 from "./Works.vue?vue&type=style&index=0&id=d67dd984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67dd984",
  null
  
)

export default component.exports